<project-template-metadata class="d-block pb-6" [project]="project$ | async"
                           [views]="views$ | async"
                           [workspace]="workspace$ | async"
                           [collections]="collections$ | async">
</project-template-metadata>
